import React from 'react';
import type { FC, ReactNode } from 'react';
import { Box } from 'ink';

interface NotificationProps {
  children: ReactNode;
}

export const Notification: FC<NotificationProps> = ({ children }) => {
  return (
    <Box>
      <Box
        padding={1}
        alignItems="center"
        flexDirection="column"
        borderColor="yellowBright"
        borderStyle="round"
      >
        {children}
      </Box>
    </Box>
  );
};
